import { render } from "./PrivacyPolicy.vue?vue&type=template&id=40e2d926"
const script = {}

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=40e2d926&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__